import React from "react";
import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link, useParams } from "react-router-dom";
import {
  primary,
  primaryAlt,
  textPrimary,
  textSecondary,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";

const Agreement = ({ noQuestion }) => {
  const { t } = useTranslation();
  const { slug } = useParams();

  return (
    <Flex
      w="100%"
      align="center"
      jusityf="center"
      position="relative"
      // pt={10}
      textAlign="center"
      direction="column"
    >
      <Text
        fontSize={["sm", "xs"]}
        fontWeight="500"
        lineHeight="1.8"
        color={textSecondary}
        maxW="300px"
      >
        {t("common.byCreatingAccount")}
        <Text
          as="span"
          color={textSecondary}
          textDecoration="underline"
          _hover={{
            color: primary,
          }}
        >
          {/* <Link to="/terms-of-service"> {t("common.termsOfService")}</Link> */}
          <Link
            to={`https://www.dentacasa.com/terms-of-use/`}
            // to="/docs/terms-of-service"
            target="_blank"
          >
            {" "}
            {t("common.termsOfService")}
          </Link>
        </Text>
        ,{" "}
        <Text
          as="span"
          color={textSecondary}
          textDecoration="underline"
          _hover={{
            color: primary,
          }}
        >
          {/* <Link to="/privacy-policy"> {t("common.privacyPolicy")}</Link> */}
          <Link
            to={`https://www.dentacasa.com/privacy-policy/`}
            // to="/docs/privacy-policy"
            target="_blank"
          >
            {" "}
            {t("common.privacyPolicy")}
          </Link>
        </Text>
        {/* , {t("common.termsAnd")} */}
        {/* <Text
          as="span"
          color={textSecondary}
          textDecoration="underline"
          _hover={{
            color: primary,
          }}
        >
          <Link to=""> {t("common.dataProcessing")}</Link>
        </Text> */}
        .
      </Text>

      {!noQuestion && (
        <Box mt={4}>
          <Text fontSize={["md", "sm"]} fontWeight="500" color={textPrimary}>
            {t("common.alreadyHaveAccount")}
            <Link to="/login">
              <Button
                ml={1}
                variant="link"
                color={primary}
                p={0}
                size="sm"
                fontSize={["md", "md"]}
                role="group"
                _hover={{
                  color: primaryAlt,
                  transition: "0.2s all",
                }}
              >
                <Text
                  as="span"
                  color={primary}
                  _groupHover={{
                    pr: "0.25rem",
                    color: primaryAlt,
                    transition: "0.2s all",
                  }}
                >
                  {t("common.login")}
                </Text>{" "}
                <Icon ml={1} h="0.6rem" as={FaArrowRightLong} />
              </Button>
            </Link>
          </Text>
        </Box>
      )}
    </Flex>
  );
};

export default Agreement;
